// extracted by mini-css-extract-plugin
module.exports = {"lia-popover":"NewPasswordField_lia-popover__psj_4","lia-popover-header":"NewPasswordField_lia-popover-header__OkP7q"};